import React, { useRef, useState } from "react";
import {
  Avatar,
  Button,
  Dropdown,
  Layout,
  message,
  Space,
  Tour,
  TourProps,
} from "antd";
import { Header, Content } from "antd/es/layout/layout";
import { useLiveQuery } from "dexie-react-hooks";
import { store } from "./Store";
import CreateNewButton from "./components/CreateNewButton";
import json from "./version.json";
import ExamDesigner from "./components/ExamDesigner";
import {
  LogoutOutlined,
  PrinterOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { AppContext, onMessage } from "./Context";
import "./App.less";
import { Login } from "./Login";
import { isWeixin } from "./Device";
import { getToken } from "./api";
import { trace } from "./behavior";

const win = global as any;

const App: React.FC = () => {
  const options = useLiveQuery(() => store.getOptions());
  const [visible, setVisible] = useState(false);
  const user = useLiveQuery(() => store.getUser());
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);

  if (!options) return null;

  const steps: TourProps["steps"] = [
    {
      title: "新增试题",
      description: "描述试题内容要求,AI会自动生成试题",
      target: () => ref1.current,
      // placement: "bottomLeft",
      nextButtonProps: {
        children: "下一步",
      },
    },
    {
      title: "调整试题",
      description: "对生成页面可以直接编辑调整",
      target: () => ref2.current,
      nextButtonProps: {
        children: "下一步",
      },
      prevButtonProps: {
        children: "上一步",
      },
    },
    {
      title: "打印试卷",
      description: "最后可以打印或者导出PDF文件",
      target: () => ref3.current,
      placement: "bottomRight",
      nextButtonProps: {
        children: "开始使用",
      },
      prevButtonProps: {
        children: "上一步",
      },
    },
  ];

  // 处理打印
  const handlePrint = async () => {
    const token = getToken();
    if (!token) {
      message.warning("请登录,以便保存试卷");
      setVisible(true);
      return;
    }
    if (isWeixin) {
      win.history.pushState(
        null,
        null,
        `${win.location.origin}?token=${token}&examPaperId=${options.editingExamId}`
      );
      message.error('请点击右上角"在浏览器中打开"后打印');
      return;
    }
    // 保存原始标题
    const originalTitle = document.title;
    const examPaper = await store.getCurrentExamPapger();
    if (!examPaper) {
      message.error("请选择试卷");
      return;
    }
    trace("print", { name: "打印", value: examPaper.name });
    // 用年月日命名
    document.title = examPaper.name || "试卷" + new Date().toLocaleDateString();
    // 触发打印
    window.print();
    // 打印对话框关闭后，恢复原始标题（setTimeout确保在打印后执行）
    setTimeout(() => {
      document.title = originalTitle;
    }, 100);
  };

  return (
    <AppContext.Provider value={{ onMessage }}>
      <Layout className="ep-app-container">
        <Header className="ep-app-header">
          <div className="logo">
            <h1>
              {/* <img src={require("./logo.png")} alt="Logo" /> */}
              <span>坚果壳试卷</span>
            </h1>
            <Space>
              <CreateNewButton
                ref={ref1}
                onLogin={() => setVisible(true)}
              ></CreateNewButton>
            </Space>
          </div>
          <Space className="app-btns">
            <Button
              ref={ref3}
              type="text"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
              className="printBtn"
            >
              打印预览
            </Button>
            {/* <Button type="text" icon={<CaretRightOutlined />} disabled>
              开始答卷
            </Button> */}
            {user && (
              <Dropdown
                menu={{
                  items: [
                    {
                      key: "logout",
                      icon: <LogoutOutlined />,
                      label: "退出登录",
                      onClick: async () => {
                        await store.logout();
                      },
                    },
                  ],
                }}
              >
                <Button
                  type="link"
                  icon={
                    <Avatar
                      shape="circle"
                      icon={<UserOutlined />}
                      src={
                        user.avatar && (
                          <img
                            draggable={false}
                            src={user.avatar}
                            alt={user.name}
                          />
                        )
                      }
                    >
                      {user.name?.[0]}
                    </Avatar>
                  }
                  title={user.name}
                ></Button>
              </Dropdown>
            )}
          </Space>
        </Header>
        <Content>
          <ExamDesigner ref={ref2}></ExamDesigner>
          <div className="ep-app-footer">v {json.version}</div>
        </Content>
      </Layout>
      <Login visible={visible} setVisible={setVisible}></Login>
      <Tour
        open={options.hideTour !== true}
        onClose={() => store.setOption("hideTour", true)}
        steps={steps}
      />
    </AppContext.Provider>
  );
};
export default App;
